import { ElementUIConst } from '@/common/const'
import { ElPagination } from 'element-plus'

ElPagination.props.layout.default = ElementUIConst.paginationLayout
ElPagination.props.pageSizes.default = ElementUIConst.paginationSizes
